export default __webpack_public_path__ + "static/media/menu_icon.b32de177.svg";